// extracted by mini-css-extract-plugin
export default {"tableWrapper":"hTjDNRsl","table":"fT9yb2rZ","interpolatedDescription":"TUN9P7Vj"};